export default __webpack_public_path__ + "static/media/care-for-life.1179d243.png";